import axios from "axios";
import * as storage from "../store/persistStore";

const client = axios.create({
  baseURL: new URL("/api", process.env.REACT_APP_URL).toString(),
  withCredentials: true,
});

const rootDomain = process.env.REACT_APP_ROOT_DOMAIN;
class BaseService {
  static cleanQueryParams(params = {}) {
    let newParams = {};
    Object.keys(params).forEach((key) => {
      const value = params[key];
      if (value !== "" && typeof value !== "undefined") {
        newParams[key] = value;
      }
    });
    return newParams;
  }

  static getAPIToken() {
    let storedSession = storage.getItem(storage.STORAGE_KEY);
    const store = JSON.parse(storedSession)?.state;
    return store?.auth?.session?.accessToken || null;
  }

  static getDomain() {
    let storedSession = storage.getItem(storage.STORAGE_KEY);
    const store = JSON.parse(storedSession)?.state;
    return store?.global?.enterprise?.subDomain || null;
  }

  static async excuteAPI(
    url,
    method = "get",
    data = null,
    addtionalOptions = {},
    additionalHdrs = {},
    forceNoAuthentication = false
  ) {
    try {
      const payloadData = data;

      let headers = {
        "Content-Type":
          additionalHdrs?.contentType || "application/json; charset=utf-8",
        Accept: "application/json",
        "Access-Control-Allow-Headers": "*",
        "Access-Control-Allow-Credentials": true,
      };

      const token = this.getAPIToken();
      const domain = this.getDomain();
      if (token && !forceNoAuthentication) {
        headers["Authorization"] = `Bearer ${token}`;
      }

      if (domain) {
        headers["domain"] = domain;
      }

      headers = {
        ...headers,
        ...additionalHdrs,
      };

      const payload = {
        ...addtionalOptions,
      };

      const hostParams = window.location.hostname.split(".");

      if (
        domain === null &&
        (hostParams[0] === "wwww" ||
          hostParams[0] === rootDomain ||
          window.location.hostname === rootDomain)
      ) {
        url = `/admin${url}`;
      }

      payload.headers = headers;
      payload.method = method;
      payload.url = url;

      if (payloadData !== null && method !== "get") {
        payload.data = payloadData.formData || payloadData;
      }

      const response = await client(payload);
      return response;
    } catch (error) {
      throw error;
    }
  }

  static uploadFile(url, data, onProgress) {
    try {
      let headers = {
        "Content-Type": "multipart/form-data",
        Accept: "application/json",
        "Access-Control-Allow-Headers": "*",
        "Access-Control-Allow-Credentials": true,
      };

      const token = this.getAPIToken();
      const domain = this.getDomain();
      if (token) {
        headers["Authorization"] = `Bearer ${token}`;
      }

      if (domain) {
        headers["domain"] = domain;
      }

      return client.post(url, data, {
        headers,
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          onProgress(percentCompleted);
        },
      });
    } catch (error) {
      throw error;
    }
  }

  static async callAPI(
    url,
    method = "GET",
    data = null,
    addtionalOptions = {},
    additionalHdrs = {},
    forceNoAuthentication = false
  ) {
    try {
      return this.excuteAPI(
        url,
        method,
        data,
        addtionalOptions,
        additionalHdrs,
        forceNoAuthentication
      );
    } catch (error) {
      return error;
    }
  }
}

export default BaseService;
